import { render, staticRenderFns } from "./facebook_page.vue?vue&type=template&id=730b8ea1"
import script from "./facebook_page.vue?vue&type=script&lang=js"
export * from "./facebook_page.vue?vue&type=script&lang=js"
import style0 from "./facebook_page.vue?vue&type=style&index=0&id=730b8ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports